"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyFormatter = void 0;
class CurrencyFormatter {
    transform(value, currencyBefore, currencySign) {
        if (!value) {
            return "";
        }
        if (currencyBefore) {
            return `${currencySign}${value}`.trim();
        }
        else {
            return `${value} ${currencySign}`.trim();
        }
    }
}
exports.CurrencyFormatter = CurrencyFormatter;
